export const TIMER_ID = 'board-timer';
export const TIMER_MAX_SECONDS = 59;
export const TIMER_MAX_MINUTES = 99;
export const TIMER_MAX_TIME = TIMER_MAX_MINUTES * 60000 + TIMER_MAX_SECONDS * 1000;
export const TIMER_DEFAULT_TIME = 5 * 60000;
